import * as React from 'react'

import { cn } from '@/lib/utils'

function Card({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      ref={ref}
      className={cn('bg-card text-foreground rounded-lg p-2 transition-colors md:p-4', className)}
      {...props}
    />
  )
}

function CardHeader({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return <div ref={ref} className={cn('mb-4 flex flex-col space-y-1.5', className)} {...props} />
}

function CardTitle({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return (
    <div ref={ref} className={cn('font-bold leading-none tracking-tight', className)} {...props} />
  )
}

function CardDescription({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      ref={ref}
      className={cn('text-muted-foreground text-sm sm:text-base', className)}
      {...props}
    />
  )
}

function CardContent({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return <div ref={ref} className={cn('space-y-2', className)} {...props} />
}

function CardFooter({ className, ref, ...props }: React.ComponentProps<'div'>) {
  return <div ref={ref} className={cn('mt-4 flex items-center', className)} {...props} />
}

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
